<div class="modal-header">
    <h4 class="modal-title">{{('diplomaSupplement_changeContactPersonTitle') | translate}}</h4>
</div>

<div class="modal-body">
    <form #form="ngForm">
        <div class="mb-1">
            <app-radio [(ngModel)]="mode" [value]="'filtered'" name="modeFiltered" [disabled]="(filtered?.total || 0) < 1">
                {{'diplomaSupplement_lblChangeContactPersonFiltered' | translate}} ({{filtered?.total || 0}})
            </app-radio>
        </div>

        <div class="mb-3">
            <app-radio [(ngModel)]="mode" [value]="'selected'" name="modeSelected" [disabled]="(selected || []).length < 1">
                {{'diplomaSupplement_lblChangeContactPersonSelected' | translate}} ({{(selected || []).length}})
            </app-radio>
        </div>

        <app-alert level="warning" *ngIf="mode == 'filtered'">
            {{'diplomaSupplement_changeContactPersonNoCriteria' | translate}}
        </app-alert>

        <div class="form-field required">
            <label class="form-label">{{'diplomaSupplement_lblContactPerson' | translate}}</label>
            <app-select name="contactPersonTo"
                        [disabled]="!hasItems"
                        [required]="true"
                        [options]="contactPersons"
                        [valueProperty]="'Upn'"
                        [displayFn]="contactPersonDisplayFn"
                        [(ngModel)]="contactPersonTo"
                        [filter]="true"
                        (selectionChange)="fetch()">
            </app-select>
        </div>
    </form>
</div>

<div class="modal-footer">
    <button class="btn btn-outline-secondary" type="button" (click)="cancel()" [disabled]="isSaving">{{'cancel' | translate}}</button>

    <button class="btn btn-primary" (click)="save()" type="button" [disabled]="isSaving || !form.valid">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isSaving"></span>
        {{'continue' | translate}}
    </button>
</div>
